import { createRouter, createWebHashHistory } from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import DefaultLayout from '@/layouts/DefaultLayout'
import JsonClasse from '@/models/Classe.json'
import JsonBanco from '@/models/Banco.json'
import JsonGenero from '@/models/Genero.json'
import JsonAtividade from '@/models/Atividade.json'
import JsonCrmContato from '@/models/CrmContato.json'
import JsonCrmContatoSetor from '@/models/CrmContatoSetor.json'
import JsonCatDefeito from '@/models/CatDefeito.json'
import JsonCatEquipamento from '@/models/CatEquipamento.json'
import JsonCatParametros from '@/models/CatParametros.json'
import JsonCatSituacao from '@/models/CatSituacao.json'
import JsonCatTipo from '@/models/CatTipo.json'
import JsonEstAnp from '@/models/EstAnp.json'
import JsonEstGrupo from '@/models/EstGrupo.json'
import JsonEstNcm from '@/models/EstNcm.json'
import JsonGrupo from '@/models/Grupo.json'
import JsonNCM from '@/models/Ncm.json'
import JsonANP from '@/models/ANP.json'

const routes = [
  {
    path: '/login',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'Login',
        component: AuthLayout,
        meta: {
          title: 'LOGIN',
        },
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: '/cliente',
        name: 'Cliente',
        meta: {},
        component: () => import('@/views/cliente/List.vue'),
      },
      {
        path: '/banco',
        name: 'Banco',
        meta: JsonBanco,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/classe',
        name: 'Classe',
        meta: JsonClasse,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/genero',
        name: 'Genero',
        meta: JsonGenero,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/produto',
        name: 'Produto',
        meta: {},
        component: () => import('@/views/produto/List.vue'),
      },
      {
        path: '/atividade',
        name: 'Atividade',
        meta: JsonAtividade,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/pedido',
        name: 'Pedido',
        meta: {},
        component: () => import('@/views/pedido/List.vue'),
      },
      {
        path: '/novopedido',
        name: 'Novo Pedido',
        meta: {},
        component: () => import('@/views/cam/pedido/Form.vue'),
      },
      {
        path: '/pedido/:id',
        name: 'Editar Pedido',
        meta: {},
        component: () => import('@/views/cam/pedido/Form.vue'),
      },
      {
        path: '/pedidos/:id',
        name: 'Lista Pedidos Campanha',
        meta: {},
        component: () => import('@/views/cam/pedido/List.vue'),
      },
      {
        path: '/campanha',
        name: 'Campanha',
        meta: {},
        component: () => import('@/views/cam/campanha/List.vue'),
      },
      {
        path: '/novacampanha',
        name: 'Nova Campanha',
        meta: {},
        component: () => import('@/views/cam/campanha/Form.vue'),
      },
      {
        path: '/campanha/:id',
        name: 'Alteração Campanha',
        meta: {},
        component: () => import('@/views/cam/campanha/Form.vue'),
      },
      {
        path: '/fornecedores',
        name: 'Cadastro Fornececedores',
        meta: {},
        component: () => import('@/views/cam/pessoa/List.vue'),
      },
      {
        path: '/condpgto',
        name: 'Cond-Pagamento',
        meta: {},
        component: () => import('@/views/cam/cond_pgto/List.vue'),
      },
      {
        path: '/crm_contato',
        name: 'Crm_contato',
        meta: JsonCrmContato,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/crm_contato_setor',
        name: 'Crm_contato_setor',
        meta: JsonCrmContatoSetor,
      },
      {
        path: '/produto',
        name: 'Produto',
        meta: {},
        component: () => import('@/views/produto/List.vue'),
      },
      {
        path: '/grupo',
        name: 'Grupo',
        meta: JsonGrupo,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/ncm',
        name: 'NCM',
        meta: JsonNCM,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/anp',
        name: 'ANP',
        meta: JsonANP,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/cat_defeito',
        name: 'Cat_defeito',
        meta: JsonCatDefeito,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/cat_equipamento',
        name: 'Cat_equipamento',
        meta: JsonCatEquipamento,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/cat_parametros',
        name: 'Cat_parametros',
        meta: JsonCatParametros,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/cat_situacao',
        name: 'Cat_situacao',
        meta: JsonCatSituacao,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/cat_tipo',
        name: 'Cat_tipo',
        meta: JsonCatTipo,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/est_anp',
        name: 'Est_anp',
        meta: JsonEstAnp,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/est_grupo',
        name: 'Est_grupo',
        meta: JsonEstGrupo,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/est_ncm',
        name: 'Est_ncm',
        meta: JsonEstNcm,
        component: () => import('@/views/default/List.vue'),
      },
      {
        path: '/notPermission',
        name: 'Sem Permissão de Acesso',
        component: () => import('@/views/NotPermission.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('token')
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
